import React from 'react'
import NAV from '../homepage/nav/Nav';
import FOOTER from '../homepage/footer/Footer'

import './testimonials.css';
import htmlpix from '../viewcoursespage/viewcourses/books/edible.jpg';
import javascriptpix from '../viewcoursespage/viewcourses/books/codarludo.png';
import reactpix from '../viewcoursespage/viewcourses/books/onshare.png';


const data = [
  {
    name: 'Edible experience',
    pix: htmlpix,
    review: 'https://edibleexperience.herokuapp.com/',
  },
  {
    name: 'Codar Ludo',
    pix: javascriptpix,
    review: 'https://codarludo.herokuapp.com/',
  },
  {
    name: 'Onshare',
    pix: reactpix,
    review: 'https://onshare.herokuapp.com/',
  }
  
];

const Testimonials = ({ show, setShow }) => {
  return (
    <div>
      <NAV show={show} />

      <div>
        <h2>Testimonial Projects</h2>

        <div className="agba">
          {data.map(({ name, pix, review,rname }, index) => {
            return (
              <div key={index} className="fam">
                <div className="imagea">
                  <img className="imageee" src={pix} alt="Avatar" />
                </div>
                <div>
                  {/* <h5 className="namee">{name}</h5> */}

                  <a
                    href={review}
                    className="projects"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {name}
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <FOOTER />
    </div>
  );
};

export default Testimonials
